import React from "react";
import {
  Card,
  Button,
  Header,
  Modal,
  Grid,
  Dimmer,
  Message,
  Loader,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { updateZoomDesktop } from "../reducers/session";
import MuteButton from "./MuteButton";
import CallButton from "./CallButton";
import VolumeIndicator from "./VolumeIndicator";
import ConnectionIndicator from "./ConnectionIndicator";
import { withTranslation } from "react-i18next";
import { indexBy } from "underscore";

const poster = require("../images/webcam_loading.jpg");

class WebCamUser extends React.Component {
  constructor(props) {
    super(props);
    this.modalStatus = this.modalStatus.bind(this);
    this.onRefresh = this.onRefresh.bind(this);

    this.state = {
      banModalOpen: false,
      muted: this.props.selected ? "false" : "true",
      bootModalOpen: false,
    };
    this.bootModalStatus = this.bootModalStatus.bind(this);
    this.webcamRef = React.createRef();
    this.webcamAudioRef = React.createRef();
    this.desktopRef = React.createRef();
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.webcamVideoStream != nextProps.webcamVideoStream ||
      this.props.desktopStream != nextProps.desktopStream ||
      this.props.maximizedUser !== nextProps.maximizedUser ||
      this.props.webcamAudioStream != nextProps.webcamAudioStream ||
      this.props.muted !== nextProps.muted ||
      this.props.exam_title !== nextProps.exam_title ||
      "bootModalOpen" in nextState ||
      "banModalOpen" in nextState
    );
  }
  componentDidMount() {
    if (
      this.props.webcamVideoStream &&
      this.props.desktopStream &&
      this.props.webcamAudioStream
    ) {
      this._setMedia();
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.webcamVideoStream !== this.props.webcamVideoStream ||
      prevProps.webcamAudioStream !== this.props.webcamAudioStream ||
      prevProps.desktopStream !== this.props.desktopStream ||
      prevProps.maximizedUser !== this.props.maximizedUser
    ) {
      this._setMedia();
    }
  }
  _setMedia() {
    // Function to handle autoplay and unmute after user interaction
    const handleUserInteraction = (element) => {
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
          element.muted = false;
          element.play().catch((err) => console.log("Play failed after unmuting", err));
        }
      });
    };
  
    // Setting remote webcam video
    if (this.webcamRef) {
      let remoteWebcam = this.webcamRef.current;
      if (remoteWebcam) {
        remoteWebcam.srcObject = this.props.webcamVideoStream;
        remoteWebcam
          .play()
          .then(() => {
            console.log("Webcam autoplayed successfully.");
          })
          .catch(() => {
            console.log("Webcam autoplay blocked, waiting for user interaction...");
            handleUserInteraction(remoteWebcam);
          });
      }
    }
  
    // Setting remote webcam audio
    if (this.webcamAudioRef) {
      let remoteWebcamAudio = this.webcamAudioRef.current;
      if (remoteWebcamAudio) {
        remoteWebcamAudio.srcObject = this.props.webcamAudioStream;  
        remoteWebcamAudio.muted = true;
        remoteWebcamAudio
          .play()
          .then(() => {
            console.log("Audio autoplayed successfully.");
          })
          .catch(() => {
            console.log("Audio autoplay blocked, waiting for user interaction...");
            handleUserInteraction(remoteWebcamAudio);
          });
      }
    }
  
    // Setting remote desktop stream
    if (this.desktopRef) {
      let remoteDesktop = this.desktopRef.current;
      if (remoteDesktop) {
        remoteDesktop.srcObject = this.props.desktopStream;
        remoteDesktop
          .play()
          .then(() => {
            console.log("Desktop stream autoplayed successfully.");
          })
          .catch(() => {
            console.log("Desktop autoplay blocked, waiting for user interaction...");
            handleUserInteraction(remoteDesktop);
          });
      }
    }
  }
  
  

  
  modalStatus() {
    this.setState({ banModalOpen: !this.state.banModalOpen });
  }
  bootModalStatus() {
    this.setState({ bootModalOpen: !this.state.bootModalOpen });
  }
  onRefresh() {
    this._setMedia();
  }
  render() {
    const {
      onMaximize,
      onZoom,
      onBan,
      onSoftBoot,
      onMoveToRoom,
      index,
      allUrlModal,
      urlModal,
      socketId,
      username,
      user_id,
      startVideoCall,
      stopVideoCall,
      disconnected,
    } = this.props;

    const selected = this.props.maximizedUser.user_id === user_id;
    const clickable = !selected;

    const style = {
      width: "100%",
      height: selected ? "100%" : "auto",
      maxHeight: selected ? "100%" : "none",
      margin: selected ? 0 : "0 0 1rem 0",
      overflow: selected ? "hidden" : "visible",
      cursor: clickable ? "pointer" : "default",
      border: "1px solid #2c3c4c",
      boxSizing: "border-box",
      zIndex: "2",
    };
    const id = selected ? "selected-user" : "";
    const badgeText =
      username && this.props.first_name && this.props.last_name
        ? `${this.props.first_name} ${this.props.last_name} (${username})`
        : username;


    const buttons = (
      <Card.Content extra className="controls">
        <div className="name-badge name-small">
          {badgeText}
        </div>
        {selected && this.props.exam_title && (
          <div className="exam-title-badge">
            {this.props.exam_title}
          </div>
        )}
        <Grid columns="equal">
          <Grid.Row>
            <Grid.Column style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }} onClick={(e) => e.stopPropagation()}>
              <Button
                size={selected ? "large" : "mini"}
                circular
                icon="ban"
                title={this.props.t("WebCamUser.ban")}
                onClick={() => this.modalStatus()}
                className="flat-button flat-button-danger"
              />
              <Button
                circular
                size={selected ? "large" : "mini"}
                icon="sign out"
                title={this.props.t("WebCamUser.signOut")}
                onClick={() => this.bootModalStatus()}
                className="flat-button flat-button-danger"
              />
              <Button
                size={selected ? "large" : "mini"}
                circular
                icon="exchange"
                title={this.props.t("WebCamUser.moveToRoom")}
                onClick={() => onMoveToRoom(user_id, username)}
                className="flat-button flat-button-primary"
              />
              <Button
                size={selected ? "large" : "mini"}
                circular
                icon="linkify"
                title={this.props.t("WebCamUser.singleLink")}
                onClick={() => urlModal(socketId)}
                className="flat-button flat-button-primary"
              />
              <MuteButton
                size={selected ? "large" : "mini"}
                user_id={user_id}
                onClick={this.props.onMute}
                muted={this.props.muted}
              />
              {selected ? (
                <CallButton
                  size={selected ? "large" : "mini"}
                  user_id={user_id}
                  startVideoCall={startVideoCall}
                  stopVideoCall={stopVideoCall}
                />
              ) : null}
              <Button
                size={selected ? "large" : "mini"}
                circular
                icon="refresh"
                title={this.props.t("WebCamUser.refresh")}
                onClick={this.onRefresh}
                className="flat-button flat-button-primary"
              />
            </Grid.Column>
            {this.props.webcamAudioStream ? (
              <Grid.Column width={5} style={{ display: "flex", alignItems: "center", gap: "8px", overflow: "hidden" }} onClick={(e) => e.stopPropagation()}>
                <div style={{ flexShrink: 0 }}>
                  <ConnectionIndicator
                    stream={this.props.webcamAudioStream}
                    peerConnection={this.props.peerConnection}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <VolumeIndicator
                    webcamStream={this.props.webcamAudioStream}
                    user_id={user_id}
                    width={290}
                  />
                </div>
                
              </Grid.Column>
            ) : null}
          </Grid.Row>
        </Grid>
      </Card.Content>
    );

    return (
      <Card
        centered
        raised
        fluid
        id={id}
        style={style}
        className={clickable ? "student-card-clickable" : undefined}
        onClick={clickable ? () => onMaximize(index) : undefined}
      >
        <Dimmer active={disconnected}>
          <Loader />
          <Message
            className="disconnected-message"
            icon
            hidden={false}
            style={{
              margin: "auto",
              textAlign: "center",
              color: "#0089a8 !important",
              background: "none !important",
              boxShadow: "none !important",
            }}
          >
            <Grid.Row>
              <Grid.Column>
                <Message.Content>
                  <Message.Header>
                    {this.props.t("WebCamUser.userDisconnectedHeader")}
                  </Message.Header>
                  {this.props.t("WebCamUser.userDisconnectedMessage")}
                </Message.Content>
              </Grid.Column>
            </Grid.Row>
          </Message>
        </Dimmer>

        <Modal open={this.state.banModalOpen} onClick={(e) => e.stopPropagation()}>
          <Modal.Header>{this.props.t("WebCamUser.banUser")}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Header>{username}</Header>
              <p>
                {this.props.t("WebCamUser.confirmBan")} {username}?
              </p>
            </Modal.Description>
            <Button primary onClick={() => {
              onBan(user_id, username);
              this.modalStatus(); 
            }}>
              {this.props.t("general.confirm")}
            </Button>
            <Button negative onClick={() => this.modalStatus()}>
              {this.props.t("general.back")}
            </Button>
          </Modal.Content>
        </Modal>
        <Modal open={this.state.bootModalOpen} onClick={(e) => e.stopPropagation()}>
          <Modal.Header>{this.props.t("WebCamUser.softBanUser")}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Header>{username}</Header>
              <p>
                {this.props.t("WebCamUser.confirmSoftBoot")} {username}?
              </p>
            </Modal.Description>
            <Button primary onClick={() => {
              onSoftBoot(user_id, username);
              this.bootModalStatus(); // Close modal after confirmation
            }}>
              {this.props.t("general.confirm")}
            </Button>
            <Button negative onClick={() => this.bootModalStatus()}>
              {this.props.t("general.back")}
            </Button>
          </Modal.Content>
        </Modal>
        <div style={{ display: "flex", flexDirection: selected ? "column" : "row", flexWrap: selected ? "nowrap" : "wrap", gap: selected ? 0 : "8px", justifyContent: "center", width: "100%", padding: selected ? 0 : "4px" }}>
          <div
            onClick={!selected ? () => onMaximize(index) : undefined}
            role={!selected ? "button" : undefined}
            tabIndex={!selected ? 0 : undefined}
            onKeyDown={!selected ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                onMaximize(index);
              }
            } : undefined}
            style={{ flex: selected ? "0 0 auto" : "1 1 100%", minWidth: selected ? 0 : "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "stretch", cursor: selected ? "default" : "pointer" }}
          >
            {selected}
            <video
              autoPlay
              muted  // Ensures autoplay works in Chrome
              height={""}
              width={""}
              poster={String(poster)}
              ref={this.webcamRef}
              onClick={selected ? () => onZoom(this.props.user_id, "webcam") : undefined}
              style={{ display: "block", width: "100%", height: selected ? "min(35vh, calc((100vh - 330px) / 2))" : "180px", maxHeight: selected ? "min(35vh, calc((100vh - 330px) / 2))" : "180px", objectFit: "contain", background: "#000", borderRadius: selected ? 0 : "4px", cursor: "pointer" }}
              id={"video_" + this.props.user_id}
            />
          </div>

          <audio
            autoPlay
            muted  // Ensures autoplay works for audio
            id={this.props.user_id + "_audio"}
            ref={this.webcamAudioRef}
          />

          {selected && (
            <div style={{ flex: "0 0 auto", minWidth: 0, width: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
              <video
                autoPlay
                muted  // Ensures autoplay works for the desktop stream
                onClick={() => onZoom(this.props.user_id)}
                height={""}
                width={""}
                poster={String(poster)}
                ref={this.desktopRef}
                id={"desktop_" + this.props.user_id}
                style={{ display: "block", width: "100%", height: "min(35vh, calc((100vh - 330px) / 2))", maxHeight: "min(35vh, calc((100vh - 330px) / 2))", objectFit: "contain", background: "#000", cursor: "pointer" }}
              />
            </div>
          )}
        </div>

        <Card.Content extra>
          <Grid columns="equal">
            <Grid.Row>
              {buttons}
              <Grid.Column width={5}></Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      zoomDesktop: state.session.zoomDesktop,
      maximizedUser: state.session.maximizedUser,
    }),
    { updateZoomDesktop }
  )(WebCamUser)
);
